// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input_2kQn7h{margin:10px 0 15px}\n", ""]);
// Exports
exports.locals = {
	"input": "input_2kQn7h"
};
module.exports = exports;
